export default __webpack_public_path__ + "static/media/aiColorActive.svg.74abcf34.svg";